// Importar los datos de configuración
import { fieldConfigurationsData } from "./fieldConfigurationsData";
import type {
  EntityFieldType,
  FieldConfigurations,
  FieldTypeConfiguration,
} from "./type";

// Exportar las configuraciones desde el archivo de datos
export const fieldConfigurations: FieldConfigurations = fieldConfigurationsData;

/**
 * Helper para obtener la configuración de un tipo de campo específico
 */
export const getFieldConfiguration = (
  fieldType: EntityFieldType,
): FieldTypeConfiguration | undefined => {
  return fieldConfigurations.find((config) => config.field === fieldType);
};
